var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIntegration24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.48 6.304c0-.862.694-1.56 1.551-1.56h11.222c.857 0 1.551.698 1.551 1.56 0 .861-.694 1.56-1.551 1.56H6.03a1.556 1.556 0 01-1.552-1.56z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.461 7.134a.963.963 0 010-1.644L5.717 2.3a.955.955 0 011.448.821v6.381a.955.955 0 01-1.448.822L.46 7.134z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.52 17.784c0 .861-.694 1.56-1.551 1.56H6.748a1.556 1.556 0 01-1.552-1.56c0-.862.694-1.56 1.552-1.56h11.22c.858 0 1.553.698 1.553 1.56z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.539 16.953a.963.963 0 010 1.644l-5.256 3.19a.955.955 0 01-1.448-.821v-6.381a.955.955 0 011.448-.822l5.256 3.19z"
  })));
}
export default SvgIconIntegration24;